import { Stack, TextField } from '@fluentui/react';
import * as React from 'react';
import { IProfileContact } from '../../../Models/Profile/IProfileContact';
import { validateEmail } from '../../../Tools/Validation';

interface IBillingFormProps {
    propertyChanged: (key: string, value: any) => void;
    contactInfo: IProfileContact;
    isLoading: boolean;
    visible: boolean;
    isValid: (valid: boolean) => void;
}

export const BillingForm: React.FunctionComponent<IBillingFormProps> = (props) => {

    const setInfoChange = (event?: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
        if (event) {
            var id = (event.target as HTMLInputElement).id;
            props.propertyChanged(id, newValue);
        }
    }

    React.useEffect(() => {
        const valid = validateEmail(props.contactInfo.billingEmail)!==null && props.contactInfo.billingStreet !== "" && props.contactInfo.billingCity !== "" && props.contactInfo.billingPostalCode !== "";
        props.isValid(valid);

    }, [props.contactInfo])


    return (
        <>
            {props.visible ?
                <Stack horizontalAlign="stretch" tokens={{ childrenGap: 15 }} >
                    <TextField id="company" key="company" label="Firma" disabled={props.isLoading} value={props.contactInfo.company}
                        onChange={setInfoChange}/>
                    <TextField id="ic" key="ic" label="IČ" disabled={props.isLoading} value={props.contactInfo.ic}
                        onChange={setInfoChange} />
                    <TextField id="dic" key="dic" label="DIČ" disabled={props.isLoading} value={props.contactInfo.dic}
                        onChange={setInfoChange} />
                    <TextField required id="billingEmail" key="billingEmail" label="Email" disabled={props.isLoading} value={props.contactInfo.billingEmail}
                        onChange={setInfoChange} />
                    <TextField required id="billingStreet" key="billingStreet" label="Ulice" disabled={props.isLoading} value={props.contactInfo.billingStreet}
                        onChange={setInfoChange} />
                    <TextField required id="billingCity" key="billingCity" label="Město" disabled={props.isLoading} value={props.contactInfo.billingCity}
                        onChange={setInfoChange} />
                    <TextField required id="billingPostalCode" key="billingPostalCode" label="PSČ" disabled={props.isLoading} value={props.contactInfo.billingPostalCode}
                        onChange={setInfoChange} />
                </Stack> : null}
        </>
    )
}

BillingForm.defaultProps = { visible: true }
